module.exports = __webpack_public_path__ + "static/img/clientConceptPic2.eb4c526.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/clientConceptPic2.jpg
// module id = D3m3
// module chunks = 0